import { createContext, useContext } from 'react';

import type { Webhook, WebhookFilter } from 'v2/interfaces/webhook2';

interface IWebhookContext {
  webhooks: Webhook[];
  loading: boolean;
  filter: WebhookFilter;
  selectedWebhook: Webhook;
  isFormOpen: boolean;
  listWebhooks: () => void;
  setSelectedWebhook: (w: Webhook) => void;
  setIsFormOpen: (fo: boolean) => void;
  setFilter: (f: WebhookFilter) => void;
  setLoading: (l: boolean) => void;
}

const WebhookContext = createContext<IWebhookContext>({} as IWebhookContext);

export function useWebhookContext() {
  const context = useContext(WebhookContext);
  return context;
}

export default WebhookContext;
